/*
 *  I11PERCHARVARII18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-20 15:31:49 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I11PERCHARVARI_SECTION_0_TITLE: 'Dimensionnez votre vanne en fonction du Kvs et de votre installation',
  I11PERCHARVARI_perteCharg_uuid: 'Unité de calcul perte de charge',
  I11PERCHARVARI_in_pertechargenominal: "Perte de charge de l'élément considéré à débit nominal",
  I11PERCHARVARI_in_debitnominal: 'Débit nominal',
  I11PERCHARVARI_res_resistanceelement: "Résistance de l'élément",
  I11PERCHARVARI_in_nouveaudebit: 'Nouveau débit souhaité',
  I11PERCHARVARI_res_ouvellepertecharge: "Nouvelle perte de charge de l'élément"
}
